import React from 'react';
import styled from '@emotion/styled';
import IconPackage from 'xiv-fanfes-2021'
import { GatsbyImage } from "gatsby-plugin-image";
import RoundButton from '../RoundButton';
import { parseHTML } from '../../functions/common'
import { useLocalization } from "gatsby-theme-i18n";
import LinkItem from "../LinkItem"
import * as breakpoint from '../../styles/breakpoints.module.scss';
import GuestList from '../GuestList';

const Card = ({ image, category,annotation, title, desc, colNum, data, time, streamingUrl, isNew, isModal, onClick, guests, performers, closePopup, outboundUrl, inboundUrl, anchor }) =>{
  
  const { t, currentLocaleObj, originalPath } = useLocalization();

  return(
  <CardWrapper 
    colnum={colNum} 
    className={`cardWrapper col_${colNum} ${isNew ? 'updated' : ''} ${isModal ? 'modal' : ''}`} 
    onClick={onClick} 
    href={anchor === "outbound" ? outboundUrl : "#"} to={anchor === "detail" ? inboundUrl : null}>
    <CardContent onClick={isModal ? (e) => {
        e.stopPropagation();
      } : null}>
      {isModal && <BtnClose href="#" onClick={closePopup} />}
      <VisualWrapper>
        <NewMark>New</NewMark>
        <TextWrapper>
          {category && <CategoryLabel>{category}</CategoryLabel>}
          {data && <DateLabel>{t(`event.date.day${data.date}.label`)}</DateLabel>}
          
          <TitleLabel>{title}</TitleLabel>
          {time && <TimeLabel>{parseHTML(time)}</TimeLabel>}
          <DescLabel>
            {desc}
            {(performers && isModal) &&
              <PerformaerLabel>
                {`${t('guest.modal.performer.label')} ${performers}`}
              </PerformaerLabel>
            }
            {(annotation && isModal) &&
              <AnnotationLabel>
                <IconPackage.Icon type={'Alert'} alt={annotation} />
                <span>{annotation}</span>
              </AnnotationLabel>
            }
          </DescLabel>
          
          {(isModal && originalPath.search(/^\/streaming/) < 0) && 
            <ButtonWrapper>
              <RoundButton color={'#F7F7FA'} size={'large'} to={`/${currentLocaleObj.prefix}/streaming/`} >{t('nav.streaming.button.label')}</RoundButton>
            </ButtonWrapper>
          }
        </TextWrapper>
        <ImageWrapper><GatsbyImage image={image} alt={title} /></ImageWrapper>
      </VisualWrapper>
      {(isModal && guests.length > 0) && 
        <GuestList list={guests} type={'modal'} />
      }
      
    </CardContent>
    {(anchor === "outbound" || anchor === "detail") &&
      <LinkLabel>
        {t('utils.button.details.label')}
        {anchor === "outbound" ? <IconPackage.Icon type={'ExternalLink'} alt={t('utils.button.details.label')} /> : <IconPackage.Icon type={'Arrow'} alt={t('utils.button.details.label')} />}
      </LinkLabel>
    }
  </CardWrapper>)
}

const InfoContent = (props) => {
  
  const {onClick, children, href, to} = props
  if(href !== "#" || to)
    return(<LinkItem {...props}>{children}</LinkItem>)
  else if(onClick !== null)
    return (<a {...props}>{children}</a>);
  else
    return (<div {...props}>{children}</div>);
}


export default Card;


const LinkLabel = styled.div`
  display:block;
  position:absolute;
  bottom:8px;
  right:8px;
  background: #F50057;
  box-shadow: 0px 6px 8px -4px rgba(255, 54, 78, 0.5);
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFF;
  letter-spacing: 0.1em;
  transition:all .3s;
  opacity:0;
  z-index:20;
  transform: translate3d(0, 0, 0);

  > svg{
    width:20px;
    height:20px;
    vertical-align: top;
    margin-left:8px;
    margin-top:1px;
  }

  a:hover  &{
    background:#FF186A;
    bottom: -24px;
    right: -24px;
    opacity:1;
  }

  a:active &{
    background:#D7004C;
    bottom: -24px;
    right: -24px;
    opacity:1;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .plainList & {
      bottom:8px;
      right:8px;
    }

    .plainList a:hover  &,.plainList  a:active &{
      bottom: 0px;
      right: 0px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 18px;
    padding: 8px 12px;
    > svg{
      width:16px;
      height:16px;
    }
    .plainList & {
    bottom:32px;
    right:0px;
    }

    .plainList a:hover  &,.plainList  a:active &{
      bottom: 16px;
      right: -16px;
    }
  }
`

const BtnClose = styled.a`
  width:64px;
  height:64px;
  position:absolute;
  top:64px;
  right:calc(50% - 928px / 2 + 64px);
  z-index:999;

  &:before,&:after{
    content:' ';
    position:absolute;
    top:50%;
    left:50%;
    width:45px;
    height:3px;
    border-radius:2px;
    transform:translate(-50%,-50%) rotate(-45deg);
    background:#FFFFFF;
  }
  &:after{
    transform:translate(-50%,-50%) rotate(45deg);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:48px;
    height:48px;
    top:32px;
    right:calc(50% - 608px / 2 + 32px);
    &:before,&:after{
      width:35px;
      height:2px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:32px;
    height:32px;
    top:16px;
    right:calc(50% - 270px / 2 + 16px);
    &:before,&:after{
      width:25px;
      height:1px;
    }
  }
`

const ImageWrapper = styled.div`
  width:100%;
  transform: translate3d(0, 0, 0);

  .modal &{
    background:#2C2C2E;
    @media only screen and (max-width: ${breakpoint.xsMax}){
      height:436px;
      .gatsby-image-wrapper{
        width:100%;
        height:100%;
      }
    }
  }
`;

const VisualWrapper = styled.div`
  position:relative;
      z-index:1;

  
  .cardWrapper.modal &:first-of-type{
    border-radius: 12px 12px 0 0;
    overflow:hidden;
  }

  .cardWrapper.modal &:last-of-type{
    border-radius: 12px;
  }
`

const PerformaerLabel = styled.div`
  font-size: 16px;
  line-height: 28px;
  font-weight:bold;
  margin-top:16px;
  color: #ECECF0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }
`

const AnnotationLabel = styled.div`
  margin-top:16px;
  

  > svg{
    width:24px;
    height:24px;
    margin-right:8px;
    vertical-align:middle;
  }
  span{
    display:inline-block;
    font-size: 14px;
    line-height: 24px;
    color: #C8C8CC;
    vertical-align:middle;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    > svg{
      width:20px;
      height:20px;
    }
    span{
      font-size: 12px;
      line-height: 20px;
    }
  }
`

const ButtonWrapper = styled.div`
  display:block;
  line-height:0;
  text-align:center;
  margin-top:48px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:16px;
  }
`

const CardContent = styled.div`
  position:relative;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  
  width:auto;
  height:100%;

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  overflow:hidden;
  transition: transform .2s;
  z-index:1;

  .cardWrapper.modal &{
    overflow:visible;
  }

  @media only screen and (min-width: ${breakpoint.mdMin}){
    .cardWrapper:not(.modal):hover & {
      transform: scale(1.15);
    }
  }

  
`;


const CardWrapper = styled(InfoContent)`
  position:relative;
  display:block;
  

  padding: ${props => 
    {
      switch(props.colnum)
      {
        case 1 : return '0px'
        case 2 : return '24px'
        case 3 : return '24px'
        case 4 : return '24px'
        default : return '0px'
      }
    }
  };

  .plainList &{
    padding: ${props => 
      {
        switch(props.colnum)
        {
          case 3 : return '24px'
          default : return '24px'
        }
      }
    }
  }


  @media only screen and (max-width: ${breakpoint.smMax}){
    padding: ${props => 
      {
        switch(props.colnum)
        {
          case 1 : return '0px'
          case 2 : return '0 12px'
          case 3 : return '0 12px'
          case 4 : return '0 12px'
          default : return '0px'
        }
      }
    };

    .plainList &{
      padding: ${props => 
        {
          switch(props.colnum)
          {
            case 3 : return '16px'
            default : return '16px'
          }
        }
      }
    }
    
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding: ${props => 
      {
        switch(props.colnum)
        {
          case 1 : return '0px'
          case 2 : return '0 8px'
          case 3 : return '0 8px'
          case 4 : return '0 8px'
          default : return '0px'
        }
      }
    };

    .plainList &{
      padding: ${props => 
        {
          switch(props.colnum)
          {
            case 3 : return '0 0 32px'
            default : return '0 0 32px'
          }
        }
      }
    }
  }

`;


const TextWrapper = styled.div`
  position:absolute;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 50%);
  background-blend-mode: darken;

  color:#FFFFFF;
  left:0;
  right:0;
  bottom:0;
  z-index:2;
  padding:32px;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:28px;

    .col_4 &{
      padding:24px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:24px;
  }


  .modal &{
    padding:96px;
    text-align:left;
    @media only screen and (max-width: ${breakpoint.smMax}){
      padding:64px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      padding:24px;
    }
  }
`

const CategoryLabel = styled.span`
  display:block;
  color: #FAFAFE;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 4px rgba(0, 0, 0, 0.2), 0px 1px 8px rgba(0, 0, 0, 0.1);
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.01em;
  margin-bottom:8px;
`

const TitleLabel = styled.span`
  display:block;
  color: #FAFAFE;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 4px rgba(0, 0, 0, 0.2), 0px 1px 8px rgba(0, 0, 0, 0.1);
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.01em;

  .col_4 &{
    font-size: 22px;
    line-height: 28px;
  }

  html[lang="de"] &,
  html[lang="fr"] & {
    font-size: 20px;
    line-height: 28px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.03em;

    .col_4 &{
      font-size: 20px;
      line-height: 28px;
    }
    html[lang="de"] &, html[lang="fr"] & {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0.03em;

    .col_4 &{
      font-size: 18px;
      line-height: 24px;
    }

    html[lang="de"] &, html[lang="fr"] &{
      font-size: 14px;
      line-height: 20px;
    }
  }


  .modal &{
    font-size: 36px;
    line-height: 48px;
    @media only screen and (max-width: ${breakpoint.smMax}){
      font-size: 28px;
      line-height: 36px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 20px;
      line-height: 28px;
    }
  }
`

const DescLabel = styled.span`
  display:block;
  color: #ECECF0;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 4px rgba(0, 0, 0, 0.2), 0px 1px 8px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  margin-top:24px;

  .col_4 &{
    font-size: 14px;
    line-height: 24px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 20px;
    margin-top:20px;
    

    .col_2 &{
      margin-top:16px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
    
    .col_4 &{
      font-size: 12px;
      line-height: 20px;
    }

    .col_2 &{
      margin-top:16px;
    }
  }

  .modal &{
    font-size: 16px;
    line-height: 28px;
    @media only screen and (max-width: ${breakpoint.smMax}){
      font-size: 14px;
      line-height: 24px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 12px;
      line-height: 20px;
    }
  }
`

const DateLabel = styled.span`
  display:block;
  font-size: 16px;
  line-height: 20px;
  color: #FAFAFE;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 4px rgba(0, 0, 0, 0.2), 0px 1px 8px rgba(0, 0, 0, 0.1);
  margin-bottom:8px;
  letter-spacing: 0.03em;
  font-weight: 900;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 20px;
    margin-bottom:6px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 16px;
    margin-bottom:4px;
  }

  .modal &{
    font-size: 24px;
    line-height: 36px;
    @media only screen and (max-width: ${breakpoint.smMax}){
      font-size: 16px;
      line-height: 24px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 14px;
      line-height: 24px;
    }
  }
`

const TimeLabel = styled.span`
  display:block;
  font-size: 13px;
  line-height: 16px;
  color: #FFC400;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 4px rgba(0, 0, 0, 0.2), 0px 1px 8px rgba(0, 0, 0, 0.1);
  margin-top:8px;
  letter-spacing: 0.03em;
  font-weight: 900;

  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:6px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:4px;
  }

  .modal &{
    font-size: 20px;
    line-height: 32px;
    @media only screen and (max-width: ${breakpoint.smMax}){
      font-size: 12px;
      line-height: 20px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 12px;
      line-height: 20px;
    }
  }
`

const NewMark = styled.div`
  display:none;
  width:6px;
  height:6px;
  border-radius: 3px;
  background:#AEEA00;
  margin-left:5px;
  position:absolute;
  top:16px;
  right:16px;
  z-index:2;
  text-indent: -9999px;
  overflow:hidden;

  .updated &{
    display:block;
  }
`
